<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

onMounted(async () => {
  // Initialize auth from stored token
  await authStore.init()
})
</script>

<template>
  <router-view />
</template>

<style>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&display=swap');

/* Element Plus theme overrides */
:root {
  --el-color-primary: var(--m2v-primary);
  --el-color-primary-light-3: var(--m2v-primary-light);
  --el-color-primary-dark-2: var(--m2v-primary-dark);
  --el-color-success: var(--m2v-success);
  --el-color-warning: var(--m2v-warning);
  --el-color-danger: var(--m2v-error);
  --el-color-info: var(--m2v-text-muted);
  
  --el-bg-color: var(--m2v-bg-surface);
  --el-bg-color-overlay: var(--m2v-bg-elevated);
  
  --el-text-color-primary: var(--m2v-text-primary);
  --el-text-color-regular: var(--m2v-text-secondary);
  --el-text-color-secondary: var(--m2v-text-muted);
  
  --el-border-color: var(--m2v-border-default);
  --el-border-color-light: var(--m2v-border-subtle);
  
  --el-fill-color-blank: var(--m2v-bg-surface);
  --el-fill-color-light: var(--m2v-bg-elevated);
  
  --el-font-family: var(--m2v-font-sans);
  --el-border-radius-base: var(--m2v-radius-md);
}

/* Dark mode specific */
[data-theme="dark"] {
  --el-mask-color: rgba(0, 0, 0, 0.8);
  --el-dialog-bg-color: var(--m2v-bg-surface);
  --el-dropdown-menuItem-hover-fill: var(--m2v-bg-elevated);
}

/* Light mode specific */
[data-theme="light"] {
  --el-mask-color: rgba(0, 0, 0, 0.5);
}

/* Global button styles */
.el-button--primary {
  --el-button-bg-color: var(--m2v-primary);
  --el-button-border-color: var(--m2v-primary);
  --el-button-hover-bg-color: var(--m2v-primary-light);
  --el-button-hover-border-color: var(--m2v-primary-light);
  --el-button-active-bg-color: var(--m2v-primary-dark);
  --el-button-active-border-color: var(--m2v-primary-dark);
}

/* Input focus styles */
.el-input__wrapper:focus-within,
.el-textarea__inner:focus {
  box-shadow: 0 0 0 1px var(--m2v-primary) !important;
}

/* Progress bar */
.el-progress-bar__outer {
  background-color: var(--m2v-bg-elevated);
}

/* Tag styles */
.el-tag--primary {
  --el-tag-bg-color: rgba(99, 102, 241, 0.1);
  --el-tag-border-color: transparent;
  --el-tag-text-color: var(--m2v-primary-light);
}

/* Dialog */
.el-dialog {
  --el-dialog-border-radius: var(--m2v-radius-xl);
}

/* Skeleton */
.el-skeleton__item {
  background: var(--m2v-bg-elevated);
}

/* Dropdown */
.el-dropdown-menu {
  background-color: var(--m2v-bg-surface);
  border-color: var(--m2v-border-subtle);
}

.el-dropdown-menu__item {
  color: var(--m2v-text-primary);
}

.el-dropdown-menu__item:hover {
  background-color: var(--m2v-bg-elevated);
  color: var(--m2v-primary-light);
}
</style>
